// 弹窗
import request from '@/utils/request'

let BulletboxApi = {

  /*列表接口*/
  BulletList(data, errorback) {
    return request._get('/shop/notice.pop/index', data, errorback);
  },
  /*详情接口*/
  BulletDetail(data, errorback) {
    return request._get('/shop/notice.pop/detail', data, errorback);
  },
  /*添加接口*/
  BulletAdd(data, errorback) {
    return request._post('/shop/notice.Pop/add', data, errorback);
  },
  /*编辑接口*/
  BulletEdit(data, errorback) {
    return request._post('/shop/notice.Pop/edit', data, errorback);
  },
  /*用户接口*/
  BulletDelete(data, errorback) {
    return request._post('/shop/notice.pop/delete', data, errorback);
  },

  /*显示接口*/
  BulletisShow(data, errorback) {
    return request._post('/shop/notice.pop/isShow', data, errorback);
  },


}
export default BulletboxApi;



// WEBPACK FOOTER //
// ./src/api/bulletbox.js